import { Button, Flex } from '@aws-amplify/ui-react';
import React from 'react';
import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';

export interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  loadingText?: string;
  variant?: 'default' | 'destructive';
  hideCancel?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isLoading = false,
  loadingText = 'Processing...',
  variant = 'default',
  hideCancel = false
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={General.getModalDefaults({ width: '450px' })}
      closeTimeoutMS={200}
      parentSelector={General.getModalRoot}
    >
      <Flex direction='column' gap={20}>
        <h3 style={{ marginTop: 0, marginBottom: 0 }}>
          {title}
        </h3>
        <div>
          {message}
        </div>
        <Flex gap={10} justifyContent='flex-end'>
          {!hideCancel && (
            <Button
              size='small'
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </Button>
          )}
          <Button
            size='small'
            variation={variant === 'destructive' ? 'destructive' : 'primary'}
            onClick={onConfirm}
            isLoading={isLoading}
            loadingText={loadingText}
          >
            {confirmText}
          </Button>
        </Flex>
      </Flex>
    </ReactModal>
  );
};

export default ConfirmModal;
